import truncate from 'lodash/truncate';

export default (shortcuts = []) =>
  shortcuts.map((shortcut) => {
    const [organization, ...topics] = shortcut;
    const { name: orgName, id: orgId } = organization;
    const rootUrl = `/videos/organizations/${orgId}/on-demand`;

    const topicCrumbs = topics.map((topic) => ({
      text: truncate(topic.name, { length: 50 }),
      key: `topic-${topic.id}`,
      path: `${rootUrl}/topics/${topic.id}`,
    }));

    return [
      {
        text: truncate(orgName, { length: 50 }),
        key: `org-${orgId}`,
        path: rootUrl,
      },
      ...topicCrumbs,
    ];
  });
